import {
  GET_ORGANIZATION_SEARCH_ERROR,
  GET_ORGANIZATION_SEARCH_START,
  GET_ORGANIZATION_SEARCH_SUCCESS,
} from 'constants/action-types/organizations/organizationSearch';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_SEARCH_START:
      return {
        ...state,
        organizationSearch: {
          ...state.organizationSearch,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_SEARCH_SUCCESS:
      return {
        ...state,
        organizationSearch: {
          ...state.organizationSearch,
          loading: false,
          items: [...payload],
        },
      };
    case GET_ORGANIZATION_SEARCH_ERROR:
      return {
        ...state,
        organizationSearch: {
          ...state.organizationSearch,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
